import { useEffect, useRef } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './authConfig';

function AutoRedirectToLogin() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();
  const redirectedRef = useRef(false);

  useEffect(() => {
    const tryLogin = async () => {
      if (
        inProgress === InteractionStatus.None &&
        !isAuthenticated &&
        !redirectedRef.current
      ) {
        redirectedRef.current = true;

        try {
          await instance.ssoSilent({
            scopes: loginRequest.scopes,
          });
        } catch (err) {
          await instance.loginRedirect();
        }
      }
    };

    tryLogin();
  }, [inProgress, isAuthenticated, instance]);

  const message =
    inProgress === InteractionStatus.Logout
      ? 'Redirecting to logout...'
      : 'Redirecting to login...';

  return (
    <div
      style={{
        height: '100vh',
        backgroundImage: 'url("/login-background.jpg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundColor: 'black',
      }}
    >
      {message}
    </div>
  );
}

export default AutoRedirectToLogin;
